"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "4s" */
    dataWowDuration: string;
    /** Detected variants: "mission-icon bg-primary" | "mission-icon bg-secondary" */
    className: string;
    /** Detected variants: "mission" | "vision" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/icons/mission.svg" | "/Templates/Doccure/img/icons/vision.svg" */
    src: string;
    /** Detected variants: "Our Mission" | "Our Vision" */
    h30Text: ReactNode;
    /** Detected variants: "To deliver compassionate, patient-first healthcare by combining expert clinical judgment with technology." | "Empower doctors to detect conditions earlier, improve outcomes, and redefine the future of modern healthcare." */
    p0Text: ReactNode;
    /** Detected variants: "col-md-6" */
    divClassName?: string;
    /** Detected variants: "mission-item wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "mission-inner" */
    div0ClassName2?: string;
    /** Detected variants: "mission-info" */
    div0ClassName3?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeTwoAboutSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "2s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Play Video · Play Video ·" */
    sectionDiv0Div0Div0Div0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "About Us" */
    sectionDiv0Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/section-icon.svg" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "We Understand That Each One Is Unique & Their" */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Health Journey." */
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "We aim to provide faster diagnosis, clearer insights, and more accurate treatment decisions ensuring every patient receives safe, precise, and personalized care." */
    sectionDiv0Div0Div1Div0Div0P0PText?: ReactNode;
    sectionDiv0Div0Div1Div0Div1ClassName?: string;
    /** Default: "all_routes.aboutUs" */
    sectionDiv0Div0Div1Div0Link0LinkHref?: string;
    /** Default: "Know More" */
    sectionDiv0Div0Div1Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div1Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    aboutSection6s: AboutSection6sItem[];
    aboutSection6sItemWrapper?: (item: AboutSection6sItem, content: ReactNode) => ReactNode;
    aboutSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageVisible?: boolean;
    aboutSection6sImageRenderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sH3Visible?: boolean;
    aboutSection6sH3Renderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwoAboutSectionGenerated: FC<HomeTwoAboutSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Button0ButtonDataText = "Play Video · Play Video ·",
    sectionDiv0Div0Div0Div0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Button0ButtonProps,
    sectionDiv0Div0Div0Div0DivDataWowDuration = "2s",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0Div0DivText = "About Us",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/section-icon.svg",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0H20H2Text = "We Understand That Each One Is Unique & Their",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText = "Health Journey.",
    sectionDiv0Div0Div1Div0Div0P0PText = "We aim to provide faster diagnosis, clearer insights, and more accurate treatment decisions ensuring every patient receives safe, precise, and personalized care.",
    sectionDiv0Div0Div1Div0Link0LinkHref = "all_routes.aboutUs",
    sectionDiv0Div0Div1Div0Link0LinkText = "Know More",
    sectionDiv0Div0Div1Div0Link0LinkVisible,
    sectionDiv0Div0Div1Div0Link0LinkRenderer,
    sectionDiv0Div0Div1Div0Link0LinkProps,
    divDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0H30H3Props,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div0Div1ClassName,
    aboutSection6s,
    aboutSection6sItemWrapper,
    aboutSection6sRenderer,
    aboutSection6sImageVisible,
    aboutSection6sImageRenderer,
    aboutSection6sH3Visible,
    aboutSection6sH3Renderer,
    aboutSection6sImageProps,
    aboutSection6sH3Props,
}) => {
    return (
        <>
            <section className="section about-section-two">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-lg-6">
                            <div className="about-img-two wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                                {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0Button0ButtonVisible, sectionDiv0Div0Div0Div0Button0ButtonRenderer, (
                                    <button type="button" className="animate-button" data-text={sectionDiv0Div0Div0Div0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Button0ButtonProps ?? {})}>
                                        <p className="button-text" />
                                        <span className="button-circle">
                                            <i className="isax isax-play" />
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-content-two">
                                <div className="section-header section-header-two">
                                    <div className="section-sub-title">
                                        {renderNode(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                        {sectionDiv0Div0Div1Div0Div0Div0DivText}
                                    </div>
                                    {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>
                                            {sectionDiv0Div0Div1Div0Div0H20H2Text}
                                            {" "}
                                            <span>{sectionDiv0Div0Div1Div0Div0H20Span0SpanText}</span>
                                        </h2>
                                    ))}
                                    <p>{sectionDiv0Div0Div1Div0Div0P0PText}</p>
                                </div>
                                <div className={sectionDiv0Div0Div1Div0Div1ClassName ?? "row g-4"}>
                                    {renderCollectionNode(
                                        aboutSection6s,
                                        (item: AboutSection6sItem) => (
                                            <div className={item.divClassName ?? "col-md-6"} key={item.key}>
                                                <div className={item.div0ClassName ?? "mission-item wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration}>
                                                    <div className={item.div0ClassName2 ?? "mission-inner"}>
                                                        <div className={item.div0ClassName3 ?? "mission-info"}>
                                                            <div className={item.className}>
                                                                {renderItemNode(aboutSection6sImageVisible, aboutSection6sImageRenderer, item, (
                                                                    <SmartImage src={item.src} alt={item.alt} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof aboutSection6sImageProps === "function" ? aboutSection6sImageProps(item) : (aboutSection6sImageProps ?? {}))} {...(typeof divDiv0Div0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                                ))}
                                                            </div>
                                                            {renderItemNode(aboutSection6sH3Visible, aboutSection6sH3Renderer, item, (
                                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSection6sH3Props === "function" ? aboutSection6sH3Props(item) : (aboutSection6sH3Props ?? {}))} {...(typeof divDiv0Div0Div0H30H3Props === "function" ? divDiv0Div0Div0H30H3Props(item) : (divDiv0Div0Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                            ))}
                                                        </div>
                                                        <p>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ),
                                        aboutSection6sItemWrapper,
                                        aboutSection6sRenderer
                                    )}
                                </div>
                                {renderNode(sectionDiv0Div0Div1Div0Link0LinkVisible, sectionDiv0Div0Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div1Div0Link0LinkHref} className="btn btn-md btn-primary" {...(sectionDiv0Div0Div1Div0Link0LinkProps ?? {})}>
                                        {sectionDiv0Div0Div1Div0Link0LinkText}
                                        <i className="isax isax-arrow-right-34 ms-2" />
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeTwoAboutSectionGenerated;
